import { commandTypes, ISWFHMessagePayload, payloadTypes, toTypes } from "../interfaces/messages";
import { TrsEventsService } from "../services/trsevents.service";

export const generateMessage = (_command: commandTypes, _to: toTypes | string, payload: payloadTypes, _trsService: TrsEventsService): ISWFHMessagePayload => ({
    RequestId: "",
    To: _to,
    Command: _command,
    SequenceNo: 1,
    RequestArgs: payload,
    JwtAuthenticationToken: _trsService.JwtAuthenticationToken,
    JwtRefreshToken: _trsService.JwtRefreshToken,
});
